export default __webpack_public_path__ + "media/INTRO.5e69a85a420c61080567e525e060a97e.mp4";